<shortcut-menu [subscription]="subscription()">
  <malfunction-item [subscription]="subscription()" [messages]="activities()" />
  <send-config-item [subscriptionId]="subscription().subscriptionId" />
  <service-documentation-item [url]="serviceDocumentationUrl" />
</shortcut-menu>
